<template>
  <figure class="background" :class="clazz"></figure>
</template>

<script>
  import $ from 'jquery'

  export default {
    name: 'background-component',
    mounted() {

      let parent = $('.' + this.clazz).parent();

      $(document).on('scroll', () => {
        let parentTop = parent.offset().top;
        let parentHeight = parent.outerHeight();
        let top = $(window).scrollTop();
        let opacity = 0;

        if (top > parentTop - (parentHeight / 2) && top < parentTop) {
          let start = parentTop - (parentHeight / 2);

          opacity = (top - start) / (parentTop - start);
        }
        else if  (top >= parentTop && top <= (parentTop + parentHeight)){
          opacity = 1;
        }
        else if(top < (parentTop + parentHeight) + (parentHeight / 2) && top > (parentTop + parentHeight)) {
          let start = parentTop + parentHeight;
          let end = parentTop + parentHeight + (parentHeight / 2);

          opacity = (top - start) / (end - start)
        }

        $('.' + this.clazz).css('opacity', opacity)
      })

    },
    props: ['clazz']
  }
</script>

<style lang="scss">
  .background {
    position: fixed;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin: 0;
    opacity: 0;
    background: no-repeat fixed center;
    background-size: cover;
    /*transition: 2s ease-in-out;*/

    &::before {
      content: '';
      position: absolute;
      top:0;
      lefT:0;
      height: 100vh;
      width: 100vw;
      background-color: rgba(#000, .45);
    }

    &__project-1 {
      background-image: url("../assets/hero-bg.jpg");
    }

    &__contact {
      background-image: url("../assets/contact-podklad.jpg");
    }

    &__project-2 {
      background-image: url("../assets/project-1-podklad.png");
    }

    &__project-3 {
      background-image: url("../assets/project-2-podklad.jpg");
    }

    &__project-4 {
      background-image: url("../assets/project-3-podklad.jpg");
    }

    &__team {
      background-image: url("../assets/team-podklad.jpg");
    }

  }

  .background__project-1 {
    opacity: 1 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/background.vue